module.exports = __webpack_public_path__ + "static/media/Otp_bank_Logo.svg.2c49a306.png";